export type LifecycleFocus =
  | { tab: 'jobs'; mode: 'train'; datasetName: string; datasetVersion: string }
  | { tab: 'jobs'; mode: 'test'; species: string; modelType: string; version: string }
  | { tab: 'models'; modelName: string; version: string; inspect: boolean }
  | { tab: 'inference'; modelName: string; version: string }
  | { tab: 'inference'; datasetName: string; datasetVersion: string };

export function splitRegisteredName(name: string): { species: string; modelType: string } | null {
  const stem = name.endsWith('_model') ? name.slice(0, -'_model'.length) : name;
  for (const modelType of ['orientation', 'full', 'lite']) {
    const suffix = `_${modelType}`;
    if (stem.endsWith(suffix) && stem.length > suffix.length) {
      return { species: stem.slice(0, -suffix.length), modelType };
    }
  }
  return null;
}

export function weightUri(modelName: string, tags: Record<string, string>): string {
  const modelType = splitRegisteredName(modelName)?.modelType;
  const keys = modelType === 'orientation'
    ? ['best_model_s3_zip_path', 'best_model_s3_path', 'best_model_pt_s3_path']
    : ['best_model_s3_path', 'best_model_pt_s3_path'];
  for (const key of keys) {
    const value = tags[key];
    if (value && value.startsWith('s3://')) return value;
  }
  for (const [key, value] of Object.entries(tags)) {
    if (key.toLowerCase().includes('preprocessor')) continue;
    if (key.toLowerCase().endsWith('_s3_path') && value.startsWith('s3://')) return value;
  }
  return '';
}
